import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._scrollToBottom()
    this._observer = new MutationObserver(() => this._scrollToBottom())
    this._observer.observe(this.element, { childList: true })
  }

  disconnect() {
    if (this._observer) this._observer.disconnect()
  }

  _scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
